import { type App } from 'vue';
import Axios from 'axios';
import { timeTableContainer, tommyContainer } from '@/widgets/Wizard/modules/container';
import { TimeTableService } from '@/widgets/Wizard/gateways/time-table/service';
import type { TimeTableGateway } from '@/widgets/Wizard/gateways/time-table';
import type { TommyGateway } from '@/widgets/Wizard/gateways/tommy';
import { Tommy3Service } from '@/widgets/Wizard/gateways/tommy3/service';
import type { Account } from '@/widgets/Wizard/models/accounts';

export function setupDependencyContainer(app: App, account: Account) {
    if (account.tommy.version === 2) {
        provideTommy2Dependencies(app, account);
    }

    if (account.tommy.version === 3) {
        provideTommy3Dependencies(app, account);
    }

    provideTimeTableDependencies(app);
}

function provideTommy2Dependencies(app: App, account: Account) {
    console.warn('Tommy 2 is not supported at this moment');

    // TODO: Implement when needed...
}

function provideTommy3Dependencies(app: App, account: Account) {
    if (!account.options.tokens.tommy3) {
        throw new Error('No tommy 3 tokens provided!');
    }

    // Tommy 3 uses separate tokens per API group...
    const operationalClient = Axios.create({
        baseURL: account.tommy.url,
        headers: {
            'X-Api-Token': account.options.tokens.tommy3.operational,
        },
    });

    const widgetClient = Axios.create({
        baseURL: account.tommy.url,
        headers: {
            'X-Api-Token': account.options.tokens.tommy3.widget,
        },
    });

    app.provide(tommyContainer.tommy3.operationalClient, operationalClient);
    app.provide(tommyContainer.tommy3.widgetClient, widgetClient);

    app.provide<TommyGateway>(tommyContainer.tommy3.gateway, new Tommy3Service(operationalClient, widgetClient));
}

function provideTimeTableDependencies(app: App) {
    const timeTableAxios = Axios.create({
        baseURL: import.meta.env.VITE_TIME_TABLE_API,
    });

    app.provide<TimeTableGateway>(timeTableContainer.gateway, new TimeTableService(timeTableAxios));
}
